import { render, staticRenderFns } from "./monitorSCAList.vue?vue&type=template&id=6ed41459&scoped=true&"
import script from "./monitorSCAList.vue?vue&type=script&lang=js&"
export * from "./monitorSCAList.vue?vue&type=script&lang=js&"
import style0 from "./monitorSCAList.vue?vue&type=style&index=0&id=6ed41459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed41459",
  null
  
)

export default component.exports